export default __webpack_public_path__ + "static/magento_service_banner-75e215906082404e47f63ce0b5429ddf.svg";